import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import { useStyles } from './styles';
import { Chip } from '@mui/material';
import { FILTERDEFAULTS, Definitions } from './definitions';
import { uppercaseFirstAll, cleanCopy, getObjectDiff, stringIt } from '../../utils';
import setFilter from 'redux/actions/setFilter';
import { useUser } from '../../hooks/useUser';
import setUserRealm from 'redux/actions/userRealm';
import moment from 'moment';
import { useVendors } from '../../hooks/useVendors';
import useRetrieveData from '../../hooks/useRetrieveData';

const SPECIAL = {
  realm: '__REALM',
  sort: '_sort',
};

export const FilterChips = (props) => {
  const { id } = props;

  const _filter = useSelector((state) => get(state, `filter.${id}`));
  const filter = props.filter || _filter;
  const user = useUser();
  const dispatch = useDispatch();
  const store = useStore();
  const vendors = useVendors(undefined, { includeUsersRealm: true, include: 'vendor', includeBuilders: true });
  const supersets = useRetrieveData(
    { url: '/supersets' },
    {
      build: ['supersets'],
      useCache: { reload: 20 },
    }
  );
  const content_realm_id = get(user, 'siteContextSelectedRealm.id');
  const users = useRetrieveData(
    { url: '/users' },
    {
      waitFor: id === 'reports.photo' ? undefined : null,
      build: ['users'],
      params: {
        filter: content_realm_id && {
          content_realm_id,
        },
      },
      useCache: { reload: 1 },
    }
  );

  const [filts, setFilts] = useState([]);
  const classes = useStyles();
  const includeRealm = get(props, 'includeRealm', get(Definitions, `${id}.includeRealm`, true));
  const dontShow = get(props, 'dontShow', ['daterange']);

  useEffect(() => {
    const diffs = getObjectDiff({ ...filter, ...(includeRealm && user.siteContextSelectedRealm ? { [SPECIAL.realm]: get(user, 'siteContextSelectedRealm.name') } : {}) }, get(FILTERDEFAULTS, id, {}));
    setFilts(diffs);
  }, [filter, user.siteContextSelectedRealm, users.data]);

  const getLabel = (filt) => {
    if (dontShow.includes(filt)) { return null }

    if (filt.name) {
      return filt.name;
    }

    let label = filt;
    const currentVal = get(filter, filt);
    const def = get(Definitions, `${id}.${filt}`, props.Definitions);

    if (typeof def === 'function') {
      label = def(currentVal, { filt, sState: store.getState(), vendors, supersets, users });
    } else if (Array.isArray(currentVal) && def && Array.isArray(def)) {
      const cv = currentVal.map(stringIt);
      const matches = def.filter((d) => cv.indexOf(stringIt(d.value)) > -1);
      label = matches.map((m) => m.title).join(', ');
    } else if (def && Array.isArray(def)) {
      label = get(
        def.find((d) => d.value === currentVal),
        'title',
        label
      );
    } else if (filt === SPECIAL.realm) {
      label = get(user, 'siteContextSelectedRealm.name');
    } else if (filt === SPECIAL.sort) {
      return Object.keys(label)[0];
    } else if (filt && filt.indexOf && filt.indexOf('date') > -1 && !isNaN(Date.parse(currentVal))) {
      // Don't display "End Date" as a chip if it's today's date
      if (filt === 'end_date' && moment().format('L') === moment(currentVal).format('L')) {
        label = undefined;
      } else {
        // Find if there's a more logical label for the start date from the definitions
        const _def = get(Definitions, `${id}.daterange`, []);
        label = get(
          _def.find(dr => get(dr,'vals.0') === currentVal),
          'title',
          ''
        ) || moment(currentVal).format('L');
      }
    } else if (Array.isArray(currentVal) && !!get(currentVal, '0.name')) {
      return currentVal;
    } else {
      label = uppercaseFirstAll(currentVal);
    }

    return label;
  };

  const onDelete = (filt, obj) => {
    if (props.onDelete) {
      return props.onDelete(filt);
    }

    const [key1, key2] = id.split('.');
    const fullkey = `${id}.${filt}`;

    if (filt === SPECIAL.realm) {
      dispatch(setUserRealm(null));
    } else {
      const resetVal = get(cleanCopy(FILTERDEFAULTS), fullkey);
      const resetFilt = { ...filter };

      if (obj && obj.id) {
        set(resetFilt, filt, get(resetFilt, filt, []).filter(f => f.id != obj.id));
      } else {
        set(resetFilt, filt, resetVal);
      }
      
      dispatch(setFilter(key1, key2, resetFilt));
    }
  };

  const canDelete = get(props, 'canDelete', true);

  const FILTS = props.filters || filts;

  let alllabels = [];

  return (
    <div className={classes.container}>
      {FILTS.filter((f) => f !== SPECIAL.sort)
        .filter((f) => !!getLabel(f))
        .map((filt, i) => {
          const label = getLabel(filt);
          if (alllabels.includes(label)) { return null }

          if (Array.isArray(label)) {
            return label.map(l => {
              if (alllabels.includes(l.name)) { return null }

              alllabels.push(l.name)
              return <Chip key={`${l.id}_${i}`} className={classes.chip} label={l.name} size="small" onDelete={!canDelete ? undefined : () => onDelete(filt, l)} />
            })
          }

          alllabels.push(label);
          return <Chip key={i} className={classes.chip} label={label} size="small" onDelete={!canDelete ? undefined : () => onDelete(filt)} />;
        })}
    </div>
  );
};
